import { render, staticRenderFns } from "./BookKeepingNavigation.vue?vue&type=template&id=ffd74d3e"
import script from "./BookKeepingNavigation.vue?vue&type=script&lang=ts"
export * from "./BookKeepingNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports